import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import type { Tables } from '@/integrations/supabase/types';

type Profile = Tables<'profiles'>;

/**
 * useProfile hook - optimized to use profile from AuthContext
 * This avoids duplicate API calls since AuthContext already fetches profile
 */
export function useProfile() {
  const { profile, loading, refetchProfile } = useAuth();

  const updateProfile = async (updates: Partial<Profile>) => {
    if (!profile) return { error: 'Not authenticated' };

    const { data, error } = await supabase
      .from('profiles')
      .update(updates)
      .eq('id', profile.id)
      .select()
      .single();

    if (!error && data) {
      // Refetch profile in AuthContext to sync state
      await refetchProfile();
    }

    return { data, error };
  };

  return { profile, loading, updateProfile };
}
